export function hasRequiredProperties<T extends object>(target: T, properties: (keyof T)[]): target is Required<T> {
  return properties.every((property) => target[property] != null);
}
